<template>
  <div style="margin-top: 30px; padding:11px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      SGK Oranı Ekle
    </button>
    <br>
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td><b> SGK Oranı</b></td>
          <td><b> Açıklama</b></td>
          <td><b> İşlemler </b></td>
        </tr>
        </thead>

        <tbody>
        <tr v-for="val in SGKRateData" v-bind:key="val.id">
          <td><b>{{ formatPercentage(val.sgkRate) }}</b></td>
          <td>{{ val.description }}</td>
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#companyDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            &nbsp;
            <button type="button" class="btn btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editSgkRate(val)">Düzenle</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="modal fade" id="companyDeleteModal" tabindex="-1" aria-labelledby="companyDeleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="companyDeleteModalLabel">Silme Onayı</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="SeniorityBurdenDelete(deleteId)">Evet, Sil</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" :class="{ 'wide-modal': step === 4 }"  style=" min-height: 500px; width: 750px; display: flex; flex-direction: column;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ isEditing ? 'SGK Oranı Düzenle' : 'SGK Oranı Ekle' }}</h5>
            <button type="button" style="background-color: #2419d2;" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body" style="overflow-y: auto;">
            <div class="mb-3">
              <label for="sgkRateInput" class="form-label">SGK Oranı</label>
              <input type="number" class="form-control" id="sgkRateInput" v-model="itemsSgkRate.sgkRate" placeholder="SGK Oranı" min="0" step="0.01">
            </div>
            <div class="mb-3">
              <label for="descriptionInput" class="form-label">Açıklama</label>
              <input type="text" class="form-control" id="descriptionInput" v-model="itemsSgkRate.description" placeholder="SGK Oranı Açıklaması">
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="isEditing ? updateSgkRate() : SeniorityCeilingSave()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck

import apiClient from "@/axios";

export default {
  name: "SGKRate",
  data() {
    return {
      SGKRateData: {},
      deleteId: null,
      isEditing: false,  // Düzenleme kontrolü
      itemsSgkRate: {
        sgkRate: null,
        description: '',
        id: null, // Güncelleme için id alanı
      },
    };
  },
  created() {
    this.getSeniortyData();
  },
  methods: {
    // SGK Oranı Kaydet
    SeniorityCeilingSave() {
      apiClient.post("/sgkRate", this.itemsSgkRate).then(res => {
        this.getSeniortyData();
        // Kaydetme işleminden sonra modalı kapat ve formu temizle
        this.itemsSgkRate = { sgkRate: null, description: '' };
      })
          .catch(error => {
            console.error("Kaydetme işlemi sırasında hata oluştu:", error);
          });
    },

    // SGK Oranı Verilerini Getir
    getSeniortyData() {
      apiClient.get("/sgkRate").then(res => {
        this.SGKRateData = res.data;
      });
    },

    // Silme ID'sini Ayarlama
    setDeleteId(id) {
      this.deleteId = id;
    },

    // Silme İşlemi
    SeniorityBurdenDelete(id) {
      apiClient.delete(`/sgkRate/${id}`)
          .then(() => {
            this.getSeniortyData();
          })
          .catch(error => {
            console.error("Silme işlemi sırasında hata oluştu:", error);
          });
    },

    formatPercentage(value) {
      if (value !== undefined && value !== null) {
        return `${parseFloat(value).toFixed(2)}%`;
      }
      return "0%";
    },

    // Düzenleme için modalı açma
    editSgkRate(sgkRate) {
      this.itemsSgkRate = {
        sgkRate: sgkRate.sgkRate,
        description: sgkRate.description,
        id: sgkRate.id
      };
      this.isEditing = true;
    },

    // SGK Oranı Güncelleme
    updateSgkRate() {
      apiClient.put(`/sgkRate/${this.itemsSgkRate.id}`, this.itemsSgkRate).then(() => {
        this.getSeniortyData();
        this.isEditing = false;
        this.itemsSgkRate = { sgkRate: null, description: '' };
      }).catch(error => {
        console.error("Güncelleme işlemi sırasında hata oluştu:", error);
      });
    },
  },
}
</script>

<style scoped>

</style>
